// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"Terms_termsContainer__2RNHB","pageHeader":"Terms_pageHeader__2fBkJ","section":"Terms_section__JWO0O","sectionHeader":"Terms_sectionHeader__3AQFF"};